import {TABLE_SIZE_L, TABLE_SIZE_M, TABLE_SIZE_S} from "../../../offerte/OfferteHelper";

export const serviziFilterRadioButtons = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "Numero seriale", value: "iccid"},
]

export const headCells = [
    {id: 'telephoneNumber', label: 'Numero di telefono', width: TABLE_SIZE_M},
    {id: 'serialNumber', label: 'Seriale', width: TABLE_SIZE_M},
    {id: 'tipoApn', label: 'Tipo APN', width: TABLE_SIZE_S},
    {id: 'nomeApn', label: 'Nome APN', width: TABLE_SIZE_S},
    {id: 'chip', label: '', width: TABLE_SIZE_L},
]

export const sortingOptions = [
    {text: "Tipologia", value: "apn_type"}
]

export const filterInitialState = {
    tags: {
        label: 'Tag',
        value: []
    },
    iccid: {
        label: 'Seriale',
        value: ""
    },
    msisdn: {
        label: 'Numero di telefono',
        value: ""
    },
    nomeApn: {
        label: "Nome APN",
        value: ""
    },
    tipoApn: {
        label: "Tipo APN",
        value: ""
    }
}
